import React, { createContext, useState } from 'react';
import { initialUnitId } from './units/unitFormModel';

type AnimateInContextValue = {
  hasAnimated: (id: string) => boolean;
  setAnimated: (id: string) => void;
};

const initialValue: AnimateInContextValue = {
  hasAnimated: () => {
    throw new Error('AnimateInContext is not initialised yet');
  },
  setAnimated: () => {
    throw new Error('AnimateInContext is not initialised yet');
  },
};

export const AnimateInContext = createContext<AnimateInContextValue>(initialValue);

export const AnimateInContextProvider = (props: { children?: React.ReactNode }) => {
  const [animatedIds, setAnimatedIds] = useState<{ [id in string]: boolean }>({ [initialUnitId]: true });

  const hasAnimated = (id: string) => animatedIds[id];

  const setAnimated = (id: string) => setAnimatedIds(previousState => ({ ...previousState, [id]: true }));

  return <AnimateInContext.Provider value={{ hasAnimated, setAnimated }}>{props.children}</AnimateInContext.Provider>;
};
